import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Box,
  Divider,
  Card,
  Switch,
  Button,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectSupplierNameFromId } from "../selectors/supplier.selector";
import { selectSupplierId, selectOrganisationId } from "../selectors/login.selector";
import TopBreadcrumbs from "../components/topBreadcrumbs.component";

import LeftSideNavbar from "../components/leftSideNavbar.component";
import {
  selectFacilityPageTab,
  selectFactoryData,
  selectFactoryNameFromId,
  selectFactoryTierFromId,
} from "../selectors/factory.selector";
import FacilityInformation from "../components/FacilityDetails/facilityInformation.component";
import FacilityInternalInformation from "../components/FacilityDetails/facilityInternalInformation.component";
import FacilityTabs from "../components/FacilityDetails/facilityTabs.component";
import FacilityComplianceStatus from "../components/FacilityDetails/facilityComplianceStatus.component";
import FacilityAuditList from "../components/FacilityDetails/facilityAuditList.component";
import FacilityInformationDrawer from "../components/FacilityDetails/facilityInformationDrawer.component";
import { getFactoryById } from "../reducers/factory.reducer";
import EditToggleSwitch from "../components/editToggleSwitch.component";
import ConfidentialBusinessInformation from "../components/confidentialBusinessInformation.component";
import AdditionalFactoryInformation from "../components/FacilityDetails/facilityAdditionalInformation.component";
import { PageStyles } from "../styles";
import {
  selectAuditList,
  selectAuditListForFactory,
  selectFactoriesWhichAreInProgressOfCapManagement,
  selectMostRecentAuditIdForFactory,
} from "../selectors/audit.selector";
import { getListOfAuditsInCapManagement, getListOfAllAudits, getAuditById } from "../reducers/audit.reducer";
import FactoryCAPStatus from "./factoryCapStatus.component";
import FacilityActionPoints from "../components/FacilityDetails/facilityActionPoints.component";
import SendNote from "../components/sendNote.component";
import { setNoteModalStatus } from "../reducers/misc.reducer";
import { getClientStatus } from "../utils/lib";

const FacilityDetails = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const selectedFactoryData = useSelector(selectFactoryData);
  const [isLoading, setIsLoading] = useState(false);
  const supplierId = useSelector(selectSupplierId);
  const orgId = useSelector(selectOrganisationId);
  const clientStatus = getClientStatus(orgId);

  useEffect(() => {
    dispatch(getListOfAuditsInCapManagement({ supplierId }));
  }, [dispatch, supplierId]);

  useEffect(() => {
    const fetchFactoryData = async () => {
      if (!selectedFactoryData || selectedFactoryData.id !== params.factoryId) {
        setIsLoading(true);
        try {
          await dispatch(
            getFactoryById({
              supplierId: supplierId,
              factoryId: params.factoryId,
            })
          );
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchFactoryData();
  }, [params.factoryId, supplierId, dispatch]);

  const selectedTab = useSelector(selectFacilityPageTab);

  useEffect(() => {
    dispatch(
      getListOfAllAudits({
        limit: 99,
        offset: 0,
        supplierId: supplierId,
      })
    );
  }, []);

  const selectAuditId = useSelector((state) =>
    selectMostRecentAuditIdForFactory(state, params.factoryId)
  );

  const factoriesWhichAreInProgressOfCapManagement = useSelector(
    selectFactoriesWhichAreInProgressOfCapManagement
  );
  return (
    <Box sx={PageStyles.containerBox}>
      <LeftSideNavbar />
      <Box sx={PageStyles.containerBoxExceptNavbar}>
        <Box sx={PageStyles.firstSectionWithBreadcrumbsAndName}>
          <TopBreadcrumbs />
          <Grid container justifyContent="space-between">
            <Grid item>
              <Typography gutterBottom sx={PageStyles.name}>
                {selectedFactoryData?.name}
                {/* {selectedFactoryData?.metadata?.tier && (
                  <Box
                    sx={PageStyles.tierAndPrivateLabel}
                    size="small"
                    variant="outlined"
                  >
                    Tier {selectedFactoryData?.metadata?.tier}
                  </Box>
                )}
                {selectedFactoryData?.metadata?.privateLabel === "Yes" && (
                  <Box
                    sx={PageStyles.tierAndPrivateLabel}
                    size="small"
                    variant="outlined"
                  >
                    Private Label
                  </Box>
                )} */}
                {selectedFactoryData?.metadata?.status === "inactive" ? (
                    <Box
                      sx={{
                        textTransform: "none",
                        p: "3px 8px",
                        ml: 2,
                        borderRadius: "6px",
                        border: "1px solid var(--Brand-300, #D0D5DD)",
                        background: "#FFF",
                        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                        color: "#344054",
                        fontSize: "12px",
                        fontWeight: 600,
                        fontFamily: "Inter, sans-serif",
                      }}
                      size="small"
                      variant="outlined"
                    >
                      Inactive
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        textTransform: "none",
                        p: "3px 8px",
                        ml: 2,
                        borderRadius: "6px",
                        border: "1px solid var(--Brand-300, #D0D5DD)",
                        background: "#FFF",
                        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                        color: "#027A48",
                        fontSize: "12px",
                        fontWeight: 600,
                        fontFamily: "Inter, sans-serif",
                      }}
                      size="small"
                      variant="outlined"
                    >
                      Active
                    </Box>
                  )}
              </Typography>
            </Grid>
            <Grid item>
                <Button
                  variant="contained"
                  sx={{
                    textTransform: "none",
                    backgroundColor: "#2D3282",
                    borderRadius: "8px",

                    padding: "8px 12px",
                    fontSize: "14px",
                    fontWeight: "600",
                    mr: 0,
                  }}
                  onClick={() => dispatch(setNoteModalStatus(true))}
                >
                  Send {clientStatus.clientName || "Client"} a note
                </Button>
            </Grid>
          </Grid>
        </Box>
        <Divider />

        <Grid container spacing={2} sx={PageStyles.secondSectionGrid}>
          <Grid item xs={12} md={12}>
            <FacilityActionPoints />
          </Grid>
          <Grid item xs={12} md={12}>
            <FacilityInformation />
          </Grid>
          {/* Internal Information */}
          {/* <Grid item xs={12}>
            <FacilityInternalInformation />
          </Grid> */}
          {/* <Grid item xs={12} md={4}>
            <ConfidentialBusinessInformation
              title="Confidential Business Information"
              confidential={true}
              type={"factory"}
            />
          </Grid> */}
          <Grid item xs={12}>
            <AdditionalFactoryInformation />
          </Grid>
          <Grid item xs={12}>
            <Card sx={PageStyles.cardForTabsAndBelow}>
              <Grid container>
                <Grid item xs={12}>
                  <FacilityTabs />
                </Grid>

                <Grid item xs={12}>
                  {selectedTab === "status" ? (
                    <>
                      {/* <Grid item xs={12}>
                        <Typography
                          sx={{
                            color: "#344054",
                            fontSize: "18px",
                            fontWeight: "700",
                            mt: 4,
                            mb: factoriesWhichAreInProgressOfCapManagement[
                              params.factoryId
                            ]
                              ? 3
                              : 2,
                          }}
                        >
                          Details from Most recent audit
                        </Typography>
                        {factoriesWhichAreInProgressOfCapManagement[
                          params.factoryId
                        ] && <FactoryCAPStatus />}
                      </Grid> */}
                      <FacilityComplianceStatus />
                    </>
                  ) : (
                    <FacilityAuditList />
                  )}
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Box>

      <SendNote type={2} />
    </Box>
  );
};

export default FacilityDetails;
